import { render, staticRenderFns } from "./ContactConsultingSettingsCreate.vue?vue&type=template&id=56e09a0e"
import script from "./ContactConsultingSettingsCreate.vue?vue&type=script&lang=js"
export * from "./ContactConsultingSettingsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports